export interface QuestionResult {
    question: QuizQuestion;
    correct: boolean;
    answer: Array<string>;
}

export type QuizQuestionConfig = Array<QuizQuestion>;

export interface QuizQuestion {
    minAnswers?: number;
    maxAnswers?: number;
    name: string;
    display: string;
    answers: {
        [key: string]: boolean
    };
}

export const MARKET_MOVEMENT_VOL = {
    name: "market_movement_vol",
    display: "Market Movement Volatility",
    answers: {
        call_increase: false,
        call_decrease: false,
        both_increase: false,
        both_decrease: true
    }
};

export const EXPIRATION_EXERCISE_ASSIGNMENT_1 = {
    name: "expiration_exercise_assignment_1",
    display: "Expiration Exercise Assignment",
    answers: {
        30: true,
        20: false,
        100: false
    }
};

export const EXPIRATION_EXERCISE_ASSIGNMENT_2 = {
    name: "expiration_exercise_assignment_2",
    display: "Expiration Exercise Assignment",
    answers: {
        greater_than: true,
        less_than: false
    }
};

export const EXPIRATION_EXERCISE_ASSIGNMENT_3 = {
    name: "expiration_exercise_assignment_3",
    display: "Expiration Exercise Assignment",
    answers: {
        before: true,
        at: false
    }
};

export const EXPIRATION_EXERCISE_ASSIGNMENT_4 = {
    name: "expiration_exercise_assignment_4",
    display: "Expiration Exercise Assignment",
    answers: {
        index_share_cash_settled: false,
        index_option_cash_settled: true,
        share_cash_settled: false
    }
};

export const EXPIRATION_EXERCISE_ASSIGNMENT_5 = {
    name: "expiration_exercise_assignment_5",
    display: "Expiration Exercise Assignment",
    answers: {
        20: false,
        30: true,
        230: false,
        120: false
    }
};

export const EXPIRATION_EXERCISE_ASSIGNMENT_6 = {
    name: "expiration_exercise_assignment_6",
    display: "Expiration Exercise Assignment",
    answers: {
        20: false,
        120: true,
        2120: false
    }
};

export const ONGOING_OBLIGATIONS_OF_POSITION_1 = {
    name: "ongoing_obligations_of_position_1",
    display: "Ongoing Obligations of Positions",
    answers: {
        credited: false,
        debited: true
    }
};

export const ONGOING_OBLIGATIONS_OF_POSITION_2 = {
    name: "ongoing_obligations_of_position_2",
    display: "Ongoing Obligations of Positions",
    answers: {
        true: true,
        false: false
    }
};

export const FINANCIAL_LOSS = {
    name: "financial_loss",
    display: "Financial Loss",
    answers: {
        strike_price: false,
        unlimited: true
    }
};

export const LEVERAGE_1 = {
    name: "leverage_1",
    display: "Leverage",
    answers: {
        100: false,
        3750: false,
        375000: true
    }
};

export const LEVERAGE_2 = {
    name: "leverage_2",
    display: "Leverage",
    answers: {
        100: false,
        1: false,
        112: true,
        1000: false
    }
};


export const questions: QuizQuestionConfig = [
    MARKET_MOVEMENT_VOL,
    EXPIRATION_EXERCISE_ASSIGNMENT_1,
    EXPIRATION_EXERCISE_ASSIGNMENT_2,
    EXPIRATION_EXERCISE_ASSIGNMENT_3,
    EXPIRATION_EXERCISE_ASSIGNMENT_4,
    EXPIRATION_EXERCISE_ASSIGNMENT_5,
    EXPIRATION_EXERCISE_ASSIGNMENT_6,
    ONGOING_OBLIGATIONS_OF_POSITION_1,
    ONGOING_OBLIGATIONS_OF_POSITION_2,
    FINANCIAL_LOSS,
    LEVERAGE_1,
    LEVERAGE_2
];
